import {mapState} from 'vuex'
import {formatUnit, getPERatio} from '@/utils'
import {getStockGene, getStockDetail, getFdStockDetail} from '@/api'
import config from '@/utils/chart/config'
import getBstockConfig from '@/utils/getBstockConfig'

export default {
  data() {
    return {
      openPanel: false,
      gene: {},
      detail: {},
      peRatio: '--'
    }
  },
  computed: {
    ...mapState(['statistic', 'dyna', 'market', 'code', 'region', 'statics', 'isIndex']),
    weicha() {
      const dyna = this.dyna
      let buySum = dyna.BuyVolume && dyna.BuyVolume.reduce((v1, v2) => v1 + v2)
      let sellSum = dyna.SellVolume && dyna.SellVolume.reduce((v1, v2) => v1 + v2)
      return Math.ceil((buySum - sellSum) / 100)
    },
    getPanelType() {
      if(!this.openPanel || this.isIndex) return ''
      if(~this.market.toLowerCase().indexOf('etf')) return 'panel-etf'
      if(this.region === 'CN') return 'panel-full'
      if(this.region === 'HK') return 'panel-full-hk'
      if(this.region === 'USA') return 'panel-full-usa'
    },
    isETF() {
      return !!~this.market.toLowerCase().indexOf('etf')
    }
  },
  filters: {
    getPrice(val, region = 'CN', code = '', market= '') {
      let config = getBstockConfig(code, region);
      if (~market.toLowerCase().indexOf('etf')) {
        config.precision = 3
      }
      return val !== undefined && !isNaN(val) && Number(val).toFixed(config.precision) || '--'
    }
  },
  watch: {
    dyna: {
      handler() {
        this.getPERatio()
      }
    }
  },
  async mounted() {
    this[`init${this.region}`]()
  },
  methods: {
    initCN () {
      this.getGene()
    },
    initUSA () {
      this.getDetail()
    },
    initHK() {
      this.getDetail()
    },
    async getGene() {
      const {market, code} = this
      const res = await getStockGene({market, code})
      if(Object.prototype.toString.call(res) === '[object Object]') {
        this.gene = res
      }
    },
    async getDetail () {
      const {market, code} = this
      const res = await getStockDetail({market, code})
      if(res.status === 0) {
        this.detail = res.data
        this.getFdStockDetail()
        this.getPERatio()
      }
    },
    async getFdStockDetail () {
      const {market, code} = this
      const {data} = await getFdStockDetail({market: market.toLocaleUpperCase(), code})
      if(data) {
        this.detail.ttmdivshr = data.DivPerShare
        this.detail.ttmepsxclx = data.EPS
        this.detail.NetProfTTM = data.NetProfTTM
        this.detail.TotalShare = data.TotalShare
        this.getPERatio()
      }
    },
    getColor(val, base) {
      base = base === undefined ? this.statistic.PreClosePrice : base
      let f = val - base
      if(f > 0) return 'rise-color'
      if(f < 0) return 'fall-color'
      return 'draw-color'
    },
    getPERatio() {
      if(this.region === 'CN') {
        this.peRatio = this.dyna.PERatio
          ? this.dyna.PERatio > 0
            ? this.dyna.PERatio.toFixed(2)
            : '亏损'
          : '--'
      } else {
        this.peRatio = getPERatio(this.detail.NetProfTTM, this.detail.TotalShare, this.code, this.dyna.LastPrice)
      }
    },
    formatUnit(val, ext = {}) {
      if(!val) return 0
      val = ext.isVol ? val / config.region[this.region].singleHand : val
      return formatUnit(val)
    }
  },
}
